<template lang="pug">
.container.is-fluid
    .columns.is-vcentered
        .column.is-narrow
            p.title.t-1 Upcoming Events
        .column.is-narrow
            b-button.t-1(type="is-link", @click="openCalendar")
              span Open on 
              font-awesome-icon(:icon="['fab', 'google']")
    .columns.is-gapless
        .column.is-narrow
            Event
        .column.is-narrow
            Event
        .column.is-narrow
            Event            
</template>

<script>
import Sidebar from "@/components/Sidebar.vue";
import Event from "@/components/Event.vue";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";

library.add(faGoogle);

export default {
  name: "Calendar",

  title: "Calendar",

  components: {
    Sidebar,
    Event
  },

  data() {
    return {
      // if the user has Google Calendar authorization
      authorized: false
    };
  },

  methods: {
    // Get events from Google Calendar
    getEvents() {
      console.log("Fetching events from Google Calendar");
    },

    // Open Google Calendar
    openCalendar() {
      console.log("open");
    }
  }
};
</script>
